import { Injectable } from '@angular/core';
import {
  CreateMyPasswordContent,
  LoginFormValidate
} from '@com-delta-idp/mnx-login-ui';
import { BehaviorSubject, Subject } from 'rxjs';
import { LoginHelperUtils } from '../../../utils/login-helper.utils';
import { LoginModalContent } from '../../models/aem';
import { error } from '../../models/reset-password-api.interface';
import { CreateMyPasswordHelperService } from '../../services/create-my-password/create-my-password-helper.service';

@Injectable({
  providedIn: 'root'
})
export class CreateMyPasswordFacadeHelper {
  aemContent!: LoginModalContent;
  pageContent$ = new BehaviorSubject<CreateMyPasswordContent | null>(null);
  unsubscribe = new Subject<void>();

  constructor(
    protected loginHelperUtils: LoginHelperUtils,
    protected createMyPasswordHelperService: CreateMyPasswordHelperService
  ) {}

  getCreateMyPasswordContent(): CreateMyPasswordContent {
    return this.pageContent$.value || ({} as CreateMyPasswordContent);
  }

  onFormFocusChange(fieldName: string): void {
    LoginFormValidate.touchCreateMyPasswordControl(
      fieldName,
      this.getCreateMyPasswordContent()
    );
  }

  onFormValueChange(): void {
    this.getCreateMyPasswordContent().formGroup.valueChanges.subscribe(() => {
      this.getCreateMyPasswordContent().formAttributes.errorCount =
        LoginFormValidate.validateFormFields(
          this.getCreateMyPasswordContent().formGroup
        );
      this.getCreateMyPasswordContent().formAttributes.errorAlertBanner =
        LoginFormValidate.getErrorAlert(
          this.getCreateMyPasswordContent().formGroup
        );
      this.getCreateMyPasswordContent().formGroup.controls[
        'confirmPassword'
      ]?.updateValueAndValidity({ onlySelf: true });
    });
  }

  showHideOverylayMessage(value: boolean): void {
    this.getCreateMyPasswordContent().showOverlayMessage = value;
  }

  resetForm = () => {
    if (this.getCreateMyPasswordContent()?.formAttributes) {
      this.getCreateMyPasswordContent().formAttributes =
        this.createMyPasswordHelperService.getFormAttributes();
      this.showHideOverylayMessage(false);
      this.getCreateMyPasswordContent().formGroup?.reset();
      this.getCreateMyPasswordContent().formGroup?.updateValueAndValidity();
      this.getCreateMyPasswordContent().pageContent.messages.cannotContainValidationList =
        [];
      this.getCreateMyPasswordContent().pageContent.messages.mustContainValidationList =
        [];
    }
  };

  handleError(errors: error[]): void {
    this.getCreateMyPasswordContent().overlayMessage =
      this.loginHelperUtils.getErrorMessageFromAem(
        this.aemContent,
        `ERROR_MSG_${errors[0]?.code}`,
        errors[0]?.code
      );
    this.showHideOverylayMessage(true);
  }

  setActionButtonDisable(value: boolean): void {
    this.getCreateMyPasswordContent().formAttributes.disableActionButton =
      value;
  }

  validateForm(): boolean {
    LoginFormValidate.touchControlsCreateMyPasswordForm(
      this.getCreateMyPasswordContent()
    );
    this.getCreateMyPasswordContent().formAttributes.submitAttempt = true;
    const errorCount = LoginFormValidate.validateFormFields(
      this.getCreateMyPasswordContent().formGroup
    );
    this.getCreateMyPasswordContent().formAttributes.errorCount = errorCount;
    this.getCreateMyPasswordContent().formAttributes.errorAlertBanner =
      LoginFormValidate.getErrorAlert(
        this.getCreateMyPasswordContent().formGroup
      );
    return errorCount > 0;
  }

  togglePassword() {
    this.getCreateMyPasswordContent().pageContent.showPassword =
      !this.getCreateMyPasswordContent().pageContent.showPassword;
  }
}
